import { Box, Heading, Img, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import imReservationCalendar from './reservation_calendar.png';

export default function NoEventTypesBanner() {
	const { t } = useTranslation();
	return (
		<Box p={4}>
			<Box>
				<Heading size="md">{t(`You don't have any reservation calendars.`)}</Heading>

				<Text my="4" color="gray.600">
					{t('Reservation calendars are web pages where people can see your availability and book events with you.')}
				</Text>
			</Box>

			<Img mt={12} src={imReservationCalendar} w="60%" minW="sm" mx="auto" shadow="md" />
			<Text></Text>
		</Box>
	);
}
